import { gql } from "@apollo/client";

export const GET_VOTING_INFORMATION_BASIS = gql`
    query GetVotingInformationBasis($language: String! = "de") {
        common_enumerations(where: { type: { _eq: 201 }, _and: { language: { _eq: $language } } }) {
            key
            label
        }
        common_key_mls(where: { language: { _eq: $language } }) {
            keyid
            name
        }
    }
`;

export const INSERT_VOTING_INFORMATION_BASIS = gql`
    mutation InsertVotingInformationBasis($objects: [survey_votings_insert_input!]!) {
        insert_survey_votings(
            objects: $objects
            on_conflict: { constraint: PK_votings, update_columns: [key1id, key2id, quorum, veto] }
        ) {
            returning {
                id
                voting_mls {
                    title
                    question
                }
            }
        }
    }
`;

export const INSERT_VOTING_OPTION_AGENDAITEM = gql`
    mutation InsertVotingOptions(
        $votingid: uuid!
        $objectVotingOptions: [survey_votingoptions_insert_input!]!
        $objectVotingAgendaitems: [survey_votingagendaitems_insert_input!]!
    ) {
        delete_survey_votingagendaitems(where: { votingid: { _eq: $votingid } }) {
            affected_rows
        }
        delete_survey_votingoptions(where: { votingid: { _eq: $votingid } }) {
            affected_rows
        }
        insert_survey_votingoptions(objects: $objectVotingOptions) {
            returning {
                id
            }
        }
        insert_survey_votingagendaitems(objects: $objectVotingAgendaitems) {
            returning {
                id
            }
        }
    }
`;

export const DELETE_VOTING = gql`
    mutation DeleteVoting($votingId: uuid!) {
        delete_survey_votings(where: { id: { _eq: $votingId } }) {
            affected_rows
        }
    }
`;

export const GET_VOTINGS_BY_AGENDAITEMID = gql`
    query GetVotingsByAgendaitemId($agendaitemid: uuid!) {
        survey_v_votings_by_agendaitem(where: { agendaitemid: { _eq: $agendaitemid } }) {
            votingid
            votingagendaitemid
            question
            title
        }
    }
`;

export const GET_VOTING_TENANTS_OPTIONS_RESULTS = gql`
    query GetVotingTenantsAndOptionsAndResults($votingagendaitemid: uuid!, $votingid: uuid!) {
        survey_v_votingtenantdetails(where: { votingagendaitemid: { _eq: $votingagendaitemid } }) {
            tenantid
            name
            option
            unitvalue: sum_unitvalue
        }
        survey_votingagendaitemresults(
            where: { votingagendaitemrealestate: { votingagendaitemid: { _eq: $votingagendaitemid } } }
        ) {
            id
            state
            unitid
            votingagendaitemrealestateid
            tenantid
            votingoptionid
        }
        survey_votingoptions(where: { votingid: { _eq: $votingid } }) {
            votingoption_mls {
                votingoptionid
                text
            }
        }
    }
`;

export const GET_VOTING_OPTIONS = gql`
    query GetVotingOptions($votingid: uuid!) {
        survey_votingoptions(where: { votingid: { _eq: $votingid } }) {
            votingoption_mls {
                votingoptionid
                text
            }
        }
    }
`;

export const UPSERT_VOTING_AGENDA_RESULTS = gql`
    mutation UpsertVotingAgendaitemResult($votingagendaitemresults: [survey_votingagendaitemresults_insert_input!]!) {
        insert_survey_votingagendaitemresults(
            objects: $votingagendaitemresults
            on_conflict: { constraint: PK_votingagendaitemresults, update_columns: votingoptionid }
        ) {
            affected_rows
        }
    }
`;

export const GET_VOTING_DETAILS = gql`
    query GetVotingDetails($votingid: uuid!, $agendaitem: uuid!, $language: String = "de") {
        survey_votings(where: { id: { _eq: $votingid } }) {
            id
            veto
            quorum
            key1id
            key1 {
                key_mls(where: { language: { _eq: $language } }) {
                    name
                }
            }
            key2id
            key2 {
                key_mls(where: { language: { _eq: $language } }) {
                    name
                }
            }
            votingagendaitems(where: { agendaitemid: { _eq: $agendaitem } }) {
                votingagendaitemrealestates {
                    realestateid
                }
            }
            voting_mls {
                id
            }
        }
    }
`;
